import styled from 'styled-components';
import ValueCell from './ValueCell';

const StyledHeader = styled.div`
  flex-grow: 1;
  font-size: 16px;
  text-align: center;
`;

export const tableColumns = [
  {
    Header: 'Importation Method',
    accessor: 'name',
    Cell: (props) => <ValueCell {...props} isReferenceType />,
    width: 20,
  },
  {
    Header: () => <StyledHeader>Attorney</StyledHeader>,
    accessor: 'Attorney-AZ.value',
    Cell: ValueCell,
    width: 20,
    justifyContent: 'center',
  },
  {
    Header: () => <StyledHeader>Forcible</StyledHeader>,
    accessor: 'Forcible-AZ.value',
    Cell: ValueCell,
    width: 20,
    justifyContent: 'center',
  },
  {
    Header: () => <StyledHeader>Attorney</StyledHeader>,
    accessor: 'Attorney-NV.value',
    Cell: ValueCell,
    width: 20,
    justifyContent: 'center',
  },
  {
    Header: () => <StyledHeader>Forcible</StyledHeader>,
    accessor: 'Forcible-NV.value',
    Cell: ValueCell,
    width: 20,
    justifyContent: 'center',
  },
  {
    Header: () => <StyledHeader>Attorney</StyledHeader>,
    accessor: 'Attorney-NM.value',
    Cell: ValueCell,
    width: 20,
    justifyContent: 'center',
  },
  {
    Header: () => <StyledHeader>Forcible</StyledHeader>,
    accessor: 'Forcible-NM.value',
    Cell: ValueCell,
    width: 20,
    justifyContent: 'center',
  },
];
